import { ActionIcon, Group } from "@mantine/core";
import FlipRounded from "@mui/icons-material/FlipRounded";
import ShuffleRounded from "@mui/icons-material/ShuffleRounded";
import clsx from "clsx";
import type { EmblaCarouselType } from "embla-carousel";
import { deckReverseAction } from "../../../../../../../../../../features/flashcards/subjectFlashcardsSlice";
import { useCustomDispatch } from "../../../../../../../../../../lib/redux/hooks";
import CardTally from "./CardTally";
import classes from "./DeckButtons.module.css";

export default function DeckButtons({
  subjectDocumentId,
  deckDocumentId,
  shuffled,
  setShuffledHandler,
  reversed,
  active,
  embla,
  flashcardTally,
}: {
  subjectDocumentId: string | undefined;
  deckDocumentId: string | undefined;
  shuffled: boolean;
  setShuffledHandler: () => void;
  reversed: boolean;
  active: number;
  embla: EmblaCarouselType | null;
  flashcardTally: number;
}) {
  const dispatch = useCustomDispatch();

  return (
    <>
      <Group justify="center">
        <ActionIcon
          size="lg"
          className={clsx(
            classes.shuffleButton,
            shuffled && classes.shuffleButtonActive
          )}
          title="Shuffle"
          variant={shuffled ? "filled" : "outline"}
          onClick={() => {
            setShuffledHandler();
          }}
        >
          <ShuffleRounded className={classes.icon} />
        </ActionIcon>
        <CardTally
          embla={embla}
          active={active}
          flashcardTally={flashcardTally}
        />
        <ActionIcon
          title="Reverse"
          size="lg"
          className={clsx(
            classes.reverseButton,
            reversed && classes.reverseButtonActive
          )}
          variant={reversed ? "filled" : "outline"}
          onClick={() => {
            subjectDocumentId &&
              deckDocumentId &&
              dispatch(
                deckReverseAction({
                  subjectDocumentId: subjectDocumentId,
                  deckDocumentId: deckDocumentId,
                })
              );
          }}
        >
          <FlipRounded className={classes.icon} />
        </ActionIcon>
      </Group>
    </>
  );
}
